export default __webpack_public_path__ + "static/summer_containers93-c648436774cee572c4151d9ded9ef5c6.webp";